import { Card, Tabs } from '@seiue/ui'
import { Page } from 'packages/components/Page'
import styled from 'styled-components'
import { LoginLog } from './components/LoginLog'
import { useState } from 'react'
import { Device } from './components/Device'
import { ModifyPassword } from './components/ModifyPassword'

/**
 * 用户账号管理页内容
 *
 * @returns React.ReactNode
 */
export const AccountManageContent: React.FC = () => {
  const [activeKey, setActiveKey] = useState<string>('loginlog')
  const tabClick = (key: string): void => setActiveKey(key)

  const tabItems = [
    {
      label: '登录日志',
      key: 'loginlog',
      children: <LoginLog tabClick={tabClick} />,
    },
    { label: '设备管理', key: 'device', children: <Device /> },
    { label: '修改密码', key: 'modifyassword', children: <ModifyPassword /> },
  ]

  return (
    <Page containerStyle={{ height: 'calc(100vh - 64px)' }}>
      <Card
        contentStyle={{
          padding: 0,
          minHeight: '75vh',
        }}
        style={{ height: '100%' }}
      >
        <TabsStyled
          activeKey={activeKey}
          onTabClick={tabClick}
          tabPosition="left"
          items={tabItems}
          tabBarStyle={{
            height: 'calc(100vh - 144px)',
            width: '160px',
            overflowY: 'auto',
            paddingTop: '20px',
          }}
        />
      </Card>
    </Page>
  )
}

const TabsStyled = styled(Tabs)`
  height: 100%;

  &&& .ant-tabs-tab {
    color: ${(props) => props.theme.text._1};
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    height: 40px;
    margin: 8px 0px 0px;
    padding: 8px 24px 8px 20px;
  }

  .ant-tabs-tab-btn {
    margin-left: -60px;
  }

  .ant-tabs-tab:hover {
    color: ${(props) => props.theme.brand._1};
  }

  .ant-tabs-tab-active {
    background-color: ${(props) => props.theme.brand._5};
    color: ${(props) => props.theme.brand._1};
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${(props) => props.theme.brand._1};
  }

  .ant-tabs-ink-bar {
    visibility: hidden;
  }
`
